import React from 'react';
import { styled } from '@compiled/react';
import { ff } from '@atlassian/jira-feature-flagging';
import { VIEW_MODES } from '@atlassian/jira-portfolio-3-common';
import Roadmap from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap';
import PlanTableAsync from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/table/async';
import { TableSkeleton } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/table/skeleton';
import UseLocalStorageCommand from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/use-local-storage-command';
import type { Props } from './types';

// When cleaning up FF com.atlassian.rm.jpo.transposition we can remove this component entirely
const RoadmapWrapper = ({ viewMode, isLoading, ...props }: Props) => {
	if (ff('com.atlassian.rm.jpo.transposition')) {
		if (ff('com.atlassian.rm.jpo.transposition.m2')) {
			return isLoading ? (
				<TableSkeleton />
			) : (
				<>
					<PlanTableAsync />
					<UseLocalStorageCommand />
				</>
			);
		}

		if (viewMode === VIEW_MODES.TIMELINE) {
			return (
				<>
					{isLoading && (
						<SkeletonWrapper>
							<TableSkeleton />
						</SkeletonWrapper>
					)}
					<Roadmap {...props} />
				</>
			);
		}

		return isLoading ? (
			<TableSkeleton />
		) : (
			<>
				<PlanTableAsync />
				<UseLocalStorageCommand />
			</>
		);
	}

	return <Roadmap {...props} />;
};

/* A hack to render the skeleton over the roadmap component, otherwise Roadmap component rows are not rendered correctly */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonWrapper = styled.div({
	zIndex: 10,
});

export default RoadmapWrapper;
